<script setup lang="ts">
import { onMounted } from 'vue';
import { useAdminSession } from '@/composables/useAdminSession';
import { useToast } from '@/composables/useToast';

const { boot } = useAdminSession();
const { message, isError, visible } = useToast();

onMounted(() => {
  void boot();
});
</script>

<template>
  <router-view />
  <div v-show="visible" id="toast" class="toast" :class="{ err: isError }">{{ message }}</div>
</template>
